exports = module.exports = require("../../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-field.recaptcha-field {\n  margin: 0;\n  min-height: 50px;\n}\n.form-field.recaptcha-field.designerMode {\n  cursor: default;\n  pointer-events: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.form-field.recaptcha-field.designerMode.missingSiteKey {\n  align-items: center;\n  background-color: #fff3f3;\n  display: flex;\n  justify-content: center;\n  text-align: center;\n}\n.form-field.recaptcha-field.designerMode.missingSiteKey .invalid-feedback {\n  font-size: 120%;\n  text-transform: uppercase;\n}\n", ""]);

// exports
